import React, { PropsWithChildren } from 'react';

import { DownloadIcon } from './icons';

import styles from './DownloadLinkStyle.module.css';

interface IDownloadLinkProps {
  href: string;
  onClick?: () => void;
}

const DownloadLink: React.FC<IDownloadLinkProps & PropsWithChildren> = (props) => (
  <a
    className={styles['od-download-link-container']}
    href={props.href}
    onClick={props.onClick}
    target="_blank"
    // Using target="_blank" without rel="noreferrer noopener"
    // is a security risk in older browsers
    // https://mathiasbynens.github.io/rel-noopener/#recommendations
    rel="noopener noreferrer"
  >
    <div className={styles['od-download-link-icon-wrapper']} title="download icon">
      <div className={styles['od-download-link-icon-container']}>
        {/* oxlint-disable-next-line typescript/no-deprecated -- Existing screens still import this icon while the icon migration is pending */}
        <DownloadIcon />
      </div>
    </div>
    {props.children}
  </a>
);

export default DownloadLink;
